export const videoStates= {
  revoked: {
    value: 0,
    name: '未过审',
    tagType: 'danger',
  },
  published: {
    value: 1,
    name: '已发布',
    tagType: 'success',
  },
  drafted: {
    value: 2,
    name: '草稿',
    tagType: '',
  },
  scheduled: {
    value: 3,
    name: '定时发布',
    tagType: 'primary',
  },
  reviewing: {
    value: 4,
    name: '待审核',
    tagType: 'warning',
  },
  publishing: {
    value: 5,
    name: '转码中',
    tagType: 'warning',
  },
};

export function findVideoState(videoStateValue) {
  for (const key in videoStates) {
    if (videoStateValue === videoStates[key].value) return [videoStates[key]];
  }
}
